import React from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./Ourservices.scss";

const services = [
  {
    key: "custom-software",
    title: "Custom Software",
    text:
      "Web, mobile, and desktop applications tailored to your workflows — built with clean UX, robust performance, and security in mind.",
    icon: "bi bi-laptop", // use -fill variants if you want even bolder look: bi bi-laptop
  },
  {
    key: "cloud-hosting",
    title: "Cloud & Hosting",
    text:
      "Reliable cloud deployment and managed hosting solutions on AWS, Google Cloud, or Azure — built for performance, uptime, and scalability.",
    icon: "bi bi-cloud-arrow-up-fill", // filled for heavier look
  },
  {
    key: "digital-marketing",
    title: "Digital Marketing",
    text:
      "Boost your online presence through SEO, social media, content marketing, and targeted ad campaigns that drive measurable growth.",
    icon: "bi bi-megaphone-fill",
  },
  {
    key: "networking",
    title: "Networks & Servers",
    text:
      "Design and deployment of enterprise-grade networks, Wi-Fi setups, firewalls, and server infrastructures — optimized for reliability.",
    icon: "bi bi-hdd-network-fill",
  },
  {
    key: "cctv",
    title: "CCTV & Access Control",
    text:
      "End-to-end surveillance and biometric access control systems for offices, hotels, and industrial facilities — secure and scalable.",
    icon: "bi bi-camera-video-fill",
  },
  {
    key: "it-support",
    title: "IT Support & Maintenance",
    text:
      "Proactive maintenance and annual maintenance contracts to keep your systems running smoothly — on-site or remote.",
    icon: "bi bi-tools", // not available as -fill; we’ll make it look heavier via CSS
  },
];

export default function Services() {
  return (
    <section className="avena-services" id="services">
      <div className="container">
        <div className="avena-services__head">
          <h2 className="avena-services__title">
            Smart Solutions. <br />
            Secure Systems. <span>Simplified IT.</span>
          </h2>

          {/* Optional supporting line (replaces the old CTA button) */}
          {/* <p className="avena-services__tagline">
            Empowering businesses through technology that performs, protects, and scales.
          </p> */}
        </div>

        <div className="row g-4 avena-services__grid">
          {services.map((s) => (
            <div className="col-12 col-md-6 col-lg-4" key={s.key}>
              <article className="avena-services__card">
                <div className="avena-services__icon" aria-hidden="true">
                  <i className={`${s.icon}`} />
                </div>

                <h3 className="avena-services__cardTitle">{s.title}</h3>

                <div className="avena-services__divider" />

                <p className="avena-services__text">{s.text}</p>
              </article>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
